export default __webpack_public_path__ + "static/media/Chaithanya.972efb26.jpeg";